import React from 'react';
import combinationImage from '../../../../../../images/combination-lock.png';

const LockNotice = () => (
  <div className="c-wrapper">
    <img src={combinationImage} alt="Customer" className="u-align-middle" />
    <div className="layout__item u-9/10 u-align-middle u-mb0">
      Clients who signed up through Squire cannot be modified, but you can save notes.
      Only clients who are created through Commander can be edited.
    </div>
  </div>
);

export default LockNotice;
